/**
 * SchemaEntityTypeahead
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Components
import EntityTypeahead from '../../../../../../../../components/EntityTypeahead';

// Selectors
import { makeSelectSchemaValue } from '../../../../../../../../services/schemas/selectors';

interface Props {
    entityTypeId?: number;
    name: string;
    validate?: Function | Function[];
    disabled?: boolean;
}

export class SchemaEntityTypeahead extends React.PureComponent<Props> {
    render() {
        const { entityTypeId, name, validate, disabled } = this.props;
        return (
            <EntityTypeahead
                name={name}
                validate={validate}
                entityTypeId={entityTypeId}
                disabled={disabled}
            />
        );
    }
}

const mapStateToProps = createStructuredSelector({
    entityTypeId: makeSelectSchemaValue('entityTypeId')
});

export default connect(mapStateToProps)(SchemaEntityTypeahead);
